import React from 'react'
import PropTypes from 'prop-types'
import ReactPlayer from 'react-player'
import MapComponent from 'components/Map'
import { formatTime } from 'utils/timer'

const videoId = 'dmDbesougG0'

export const TaskTimer = ({
  classes,
  countdownValue,
  dumoDesc,
  stopDumoTimer,
}) => (
  <div>
    <h1 className={classes.centered}>{dumoDesc}</h1>
    <div className={classes.timerWindow} onClick={stopDumoTimer}>
      {formatTime(countdownValue)}
    </div>
    <div className={classes.mapContainer}>
      <MapComponent />
    </div>
    <ReactPlayer
      controls={true}
      playing
      url={`https://www.youtube.com/watch?v=${videoId}&t=30s`}
      width={'100%'}
    />
  </div>
)

TaskTimer.propTypes = {
  classes: PropTypes.object,
  stopDumoTimer: PropTypes.func.isRequired,
  countdownValue: PropTypes.number.isRequired,
  dumoDesc: PropTypes.string.isRequired,
}

export default TaskTimer



// WEBPACK FOOTER //
// ./src/components/TaskTimer/TaskTimer.js